var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"table-empty"},[_c('div',{staticClass:"i-rank-empty"}),_c('div',{staticClass:"mt-12 mb-28"},[_vm._v("暂无相关数据")])])
}]

export { render, staticRenderFns }